import React from 'react'

import RightDatesSection from '../../../../ReusableSections/RightDatesSection'
import CampaignsSection from '../../../../ReusableSections/CampaignsSection'
import RightAllocationAndDelivery from '../../../../ReusableSections/RightAllocationAndDelivery'
import RequestAssetsSection from '../../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../../ReusableSections/ActionsOrCommentsSection'

function RegularOnsiteRightCreateSections({ formik }) {
  return (
    <>
      <RightDatesSection formik={formik} />
      <CampaignsSection formik={formik} />
      <RightAllocationAndDelivery
        formik={formik}
        sectionDescription="Please enter the number of impressions to be provided under this right. "
        showUnitsField={false}
        showDeliveredAmountSection={false}
      />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default RegularOnsiteRightCreateSections
